import React, { useState, useEffect } from 'react';
import { Checkbox } from 'antd';
import CheckboxWithLoginModal from 'components/organisms/CheckboxWithLoginModal';

interface CheckboxWithLoginProps {
    checked?: boolean;
    disabled?: boolean;
    onChange?: (e: any) => void;
    datatestid?: string;
}

const CheckboxWithLogin: React.FC<CheckboxWithLoginProps> = ({ checked = false, disabled = false, onChange, datatestid="" }) => {
    const [isCheckboxLoginModalVisible, setIsCheckboxLoginModalVisible] = useState(false);
    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleLoginSuccess = () => {
        setIsCheckboxLoginModalVisible(false);
        setIsChecked(true);
        onChange && onChange({ target: { checked: true } });
    };

    const handleLoginCancel = () => {
        setIsCheckboxLoginModalVisible(false);
        setIsChecked(false);
        onChange && onChange({ target: { checked: false } });
    };

    const handleCheckboxChange = (e: any) => {
        if (e.target.checked) {
            setIsCheckboxLoginModalVisible(true); 
        } else {
            setIsChecked(false);
            onChange && onChange(e)
        }
    };

    return (
        <div>
            <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                disabled={disabled}
                data-testid={datatestid}
            >
                Show Sensitive Data
            </Checkbox>

            {isCheckboxLoginModalVisible && <CheckboxWithLoginModal
                loginModalVisible={isCheckboxLoginModalVisible}
                onCancel={handleLoginCancel}
                onCheckboxLoginSuccess={handleLoginSuccess}
            />}
        </div>
    );
};

export default CheckboxWithLogin;
